import { Controller, useForm } from "react-hook-form";
import { Stethoscope } from "lucide-react";
import { MEDICAL_PROFESSIONS } from "enums";
import CustomDropdownProfession from "components/dropdown-profession";

const ProfessionStep = ({ onNext }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { profession: null } });

  const onSubmit = ({ profession }) => {
    onNext(profession);
  };

  return (
    <>
      {/* Progress bar */}
      <div className="flex items-center gap-2 mb-7">
        <div className="h-1.5 flex-1 rounded-full bg-accent" />
        <div className="h-1.5 flex-1 rounded-full bg-rule" />
        <span className="text-[11px] text-muted shrink-0 ml-1">1 of 2</span>
      </div>

      {/* Icon */}
      <div className="w-10 h-10 rounded-full bg-shade-50 flex items-center justify-center mb-4">
        <Stethoscope className="w-5 h-5 text-accent" />
      </div>

      <h2 className="text-[22px] font-bold text-ink mb-1 leading-tight">
        What's your specialty?
      </h2>
      <p className="text-[13px] text-muted mb-6">
        This helps us tailor your note templates to how you practice.
      </p>

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Controller
          name="profession"
          control={control}
          rules={{ required: "Please select your profession to continue" }}
          render={({ field: { onChange, value } }) => (
            <CustomDropdownProfession
              value={value}
              className="w-full"
              onSelect={onChange}
              options={MEDICAL_PROFESSIONS}
              placeholder={value ? undefined : "Search or choose your profession"}
            />
          )}
        />
        {errors.profession && (
          <p role="alert" className="text-danger text-[11px] mt-1.5">
            {errors.profession.message}
          </p>
        )}

        <button
          type="submit"
          className="w-full mt-6 h-[46px] rounded-ns bg-accent text-white text-[15px] font-bold  transition-all duration-200 "
        >
          Continue →
        </button>
      </form>
    </>
  );
};

export default ProfessionStep;
